import type { DocumentByPathResult } from './view-document';

import { Box, Heading, Link, Text, VStack } from '@chakra-ui/react';
import { Suspense } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { DocumentUploadsPanel } from './document-uploads-panel';

export function DocumentFilesPage({
  documentResult,
  requestedPath,
  apiHost,
  userEmail,
}: {
  documentResult: DocumentByPathResult;
  requestedPath: string;
  apiHost: string;
  userEmail: string;
}) {
  const doc = documentResult?.__typename === 'Document' ? documentResult : null;

  if (!doc) {
    return (
      <Box width="100%" p={4} maxW="2xl" mx="auto">
        <VStack gap={3} align="stretch">
          <Heading size="md" color="fg">
            Files
          </Heading>
          <Text color="fg.muted" fontSize="sm">
            No document at “{requestedPath}”. Create the document first, then
            upload files from the editor.
          </Text>
          <Link
            asChild
            color="blue.600"
            fontSize="sm"
            _hover={{ textDecoration: 'underline' }}
          >
            <RouterLink to={`/documents/${requestedPath}`}>
              Open document path
            </RouterLink>
          </Link>
        </VStack>
      </Box>
    );
  }

  return (
    <Box width="100%" p={4} maxW="4xl" mx="auto">
      <VStack gap={4} align="stretch">
        <VStack gap={1} align="stretch">
          <Heading size="lg" color="fg">
            Files
          </Heading>
          <Text color="fg.muted" fontSize="sm">
            Uploads linked to this document (newest first).
          </Text>
          <Link
            asChild
            color="blue.600"
            fontSize="sm"
            _hover={{ textDecoration: 'underline' }}
          >
            <RouterLink to={`/documents/${doc.path}`}>
              Back to document
            </RouterLink>
          </Link>
        </VStack>
        <Suspense fallback={<Text color="fg.muted">Loading uploads…</Text>}>
          <DocumentUploadsPanel
            variant="page"
            documentId={doc.id}
            apiHost={apiHost}
            userEmail={userEmail}
            documentPath={doc.path}
          />
        </Suspense>
      </VStack>
    </Box>
  );
}
